export default __webpack_public_path__ + "static/media/TR.210271e9.svg";